export function buscarParametroExercicio() {
  return new Promise(async (resolve, _reject) => {
    window.$http.get("/parametroexercicios").then((res) => {
      resolve(res);
    });
  });
}
export function cadastraParametroExercicio(parametroExercicios) {
  return new Promise(async (resolve, _reject) => {
    window.$http.post(`/parametroexercicios`, JSON.stringify(parametroExercicios)).then((res) => {
      resolve(res);
    });
  });
}

export function updateParametroExercicio(id, parametroExercicios) {
  return new Promise(async (resolve, _reject) => {
    window.$http.put(`/parametroexercicios/${id}`, JSON.stringify(parametroExercicios)).then((res) => {
      resolve(res);
    });
  });
}

export function findByIdExercicio(id, exercicio) {
  return new Promise(async (resolve, _reject) => {
    window.$http.get(`/parametroexercicios/exercicio/${id}`, JSON.stringify(exercicio)).then((res) => {
      resolve(res);
    });
  });
}

export function findByIdCycle(idCycle) {
  return new Promise(async (resolve, _reject) => {
    window.$http.get(`/ciclos/exercicio/${idCycle}`).then((res) => {
      resolve(res);
    });
  });
}

export function cadastraCicloExercicio(ciclo) {
  return new Promise(async (resolve, _reject) => {
    window.$http.post(`/ciclos/v2`, JSON.stringify(ciclo)).then((res) => {
      resolve(res);
    });
  });
}

export function abrirCiclo(ciclo) {
  return new Promise(async (resolve, _reject) => {
    window.$http.post(`/ciclos/abrir`, JSON.stringify(ciclo)).then((res) => {
      resolve(res);
    });
  });
}

export function fecharCiclo(ciclo) {
  return new Promise(async (resolve, _reject) => {
    window.$http.post(`/ciclos/fechar`, JSON.stringify(ciclo)).then((res) => {
      resolve(res);
    });
  });
}

export function updateCiclo(id, ciclo) {
  return new Promise(async (resolve, _reject) => {
    window.$http.put(`/ciclos/v2/${id}`, JSON.stringify(ciclo)).then((res) => {
      resolve(res);
    });
  });
}
